import axios from "axios"
import { OTPRequest } from "../otp/dto"
import { LoginRequestDTO } from "./dto"
import { LoginService } from "./service"


export class LoginServiceImpl implements LoginService {

    public login(request: LoginRequestDTO): Promise<string> {
        let url: string = "/api/auth/login"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.data)
    }

    public OTP(request: OTPRequest, token: string): Promise<void> {
        let url: string = "/api/verify/request"

        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Authorization: token,
                Accept: '*/*',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.data)
    }

    public verifyToken(token: string): Promise<void> {
        let url: string = "/api/auth/verify"

        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: token,
                Accept: '*/*',
                'Content-Type': 'application/json'
            }
        }).then((response) => response.data)
    }
}
